// // // // // import React, { useState } from 'react';
// // // // // import {
// // // // //     Dialog,
// // // // //     DialogTitle,
// // // // //     DialogContent,
// // // // //     DialogActions,
// // // // //     IconButton,
// // // // //     Button,
// // // // //     Box,
// // // // //     Typography,
// // // // //     Grid,
// // // // // } from '@mui/material';
// // // // // import { Close as CloseIcon } from '@mui/icons-material';
// // // // // import { Formik, Form, Field } from 'formik';

// // // // // import { FaPlus } from "react-icons/fa6";
// // // // // import { MdPayment } from 'react-icons/md';

// // // // // import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// // // // // import '../../ContentManagement/Home/Modal/BannerinputGetModal.css'// Import external CSS
// // // // // import { MdCancel } from "react-icons/md";
// // // // // import * as Yup from 'yup';
// // // // // import { FiUpload } from 'react-icons/fi';
// // // // // import FileUploadComponent from '../../../Components/FileUploadComponent/FileUploadComponent';
// // // // // import ActiveInactiveRadio from '../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
// // // // // import CustomDateInput from '../../../Components/CustomDate/CustomDateInput';
// // // // // import CustoDropDownRegister from '../../../Components/CustomDropDown/CustoDropDownRegister';
// // // // // import CustomDropdownDocumentType from '../../../Components/CustomDropDown/CustomDropdownDocumentType';
// // // // // import FileUploadForCreateUser from '../../../Components/FileUploadComponent/FileUploadForCreateUser';

// // // // // const UserRoleCreateModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName }) => {
// // // // //     // const [uploadedFile, setUploadedFile] = useState(null);
// // // // //     const [uploadedFiles, setUploadedFiles] = useState([])
// // // // //     const [selectedDocumentType, setSelectedDocumentType] = React.useState('');
// // // // //     const [activeTab, setActiveTab] = useState("Dashboard");

// // // // //     const initialValues = {
// // // // //         userRole: "",
// // // // //         status: "Active",
// // // // //         permissions: {
// // // // //             Dashboard: {
// // // // //                 allUserList: { add: false, edit: false, delete: false, view: false },
// // // // //             },
// // // // //             OperatorRegistration: {
// // // // //                 purchaserList: { add: false, edit: false, delete: false, view: false },
// // // // //             },
// // // // //             SchemeManagement: {
// // // // //                 referrerList: { add: false, edit: false, delete: false, view: false },
// // // // //             },
// // // // //             ContentManagement: {
// // // // //                 financialConsultantList: {
// // // // //                     add: false,
// // // // //                     edit: false,
// // // // //                     delete: false,
// // // // //                     view: false,
// // // // //                 },
// // // // //             },
// // // // //         },
// // // // //     };

// // // // //     const handleSubmit = (values) => {
// // // // //         console.log("Form Data:", values);
// // // // //     };

// // // // //     return (
// // // // //         <Dialog
// // // // //             open={open}
// // // // //             onClose={onClose}
// // // // //             fullWidth
// // // // //             maxWidth="md"
// // // // //             className="custom-dialog"
// // // // //             sx={{
// // // // //                 // maxWidth: "700px",
// // // // //                 // margin: "auto",
// // // // //                 "& .MuiPaper-root": {
// // // // //                     borderRadius: "14px", // Target the Paper component
// // // // //                 },
// // // // //             }}
// // // // //         >
// // // // //             <Box sx={{ position: 'relative' }}>
// // // // //                 <Box className="dialog-heading">
// // // // //                     <IconButton
// // // // //                         aria-label="Close"
// // // // //                         onClick={onClose}
// // // // //                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
// // // // //                     >
// // // // //                         <MdCancel />
// // // // //                     </IconButton>
// // // // //                     <DialogTitle className="custom-dialog-title">

// // // // //                         <Box>
// // // // //                             <Typography className="custom-title-text" color='white'>
// // // // //                                 {modalHeadingName}
// // // // //                             </Typography>
// // // // //                         </Box>
// // // // //                     </DialogTitle>
// // // // //                 </Box>

// // // // //                 <Formik
// // // // //                     initialValues={initialValues}
// // // // //                     onSubmit={handleSubmit}
// // // // //                 >
// // // // //                     {({ values, setFieldValue }) => (
// // // // //                         <Form className="create-user-role">
// // // // //                             <h3>Create User Role</h3>

// // // // //                             {/* User Role Field */}
// // // // //                             <div>
// // // // //                                 <label>User Role:</label>
// // // // //                                 <Field
// // // // //                                     type="text"
// // // // //                                     name="userRole"
// // // // //                                     placeholder="Enter user role"
// // // // //                                 />
// // // // //                             </div>

// // // // //                             {/* Status Radio Buttons */}
// // // // //                             <div>
// // // // //                                 <label>Status:</label>
// // // // //                                 <label>
// // // // //                                     <Field type="radio" name="status" value="Active" />
// // // // //                                     Active
// // // // //                                 </label>
// // // // //                                 <label>
// // // // //                                     <Field type="radio" name="status" value="Inactive" />
// // // // //                                     Inactive
// // // // //                                 </label>
// // // // //                             </div>

// // // // //                             {/* Tabs */}
// // // // //                             <div className="tabs">
// // // // //                                 {Object.keys(values.permissions).map((tab) => (
// // // // //                                     <button
// // // // //                                         key={tab}
// // // // //                                         type="button"
// // // // //                                         onClick={() => setActiveTab(tab)}
// // // // //                                         className={activeTab === tab ? "active" : ""}
// // // // //                                     >
// // // // //                                         {tab}
// // // // //                                     </button>
// // // // //                                 ))}
// // // // //                             </div>

// // // // //                             {/* Checkboxes for Active Tab */}
// // // // //                             <div className="checkboxes">
// // // // //                                 {Object.keys(values.permissions[activeTab]).map((list) => (
// // // // //                                     <div key={list}>
// // // // //                                         <h4>{list}</h4>
// // // // //                                         {["add", "edit", "delete", "view"].map((action) => (
// // // // //                                             <label key={action}>
// // // // //                                                 <Field
// // // // //                                                     type="checkbox"
// // // // //                                                     name={`permissions.${activeTab}.${list}.${action}`}
// // // // //                                                 />
// // // // //                                                 {action.charAt(0).toUpperCase() + action.slice(1)}
// // // // //                                             </label>
// // // // //                                         ))}
// // // // //                                     </div>
// // // // //                                 ))}
// // // // //                             </div>

// // // // //                             {/* Submit Button */}
// // // // //                             <button type="submit">Submit</button>
// // // // //                         </Form>
// // // // //                     )}
// // // // //                 </Formik>

// // // // //             </Box >
// // // // //         </Dialog >
// // // // //     );
// // // // // };

// // // // // export default UserRoleCreateModal;

// // import React, { useState } from 'react';
// // import {
// //     Dialog,
// //     DialogTitle,
// //     IconButton,
// //     Box,
// //     Typography,
// //     Grid,
// //     DialogContent,
// // } from '@mui/material';
// // import { MdCancel } from 'react-icons/md';
// // import { Formik, Form, Field } from 'formik';
// // import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// // import ActiveInactiveRadio from '../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
// // import UserRoleTab from './UserRoleTab/UserRoleTab';
// // // import './UserRoleCreateModal.css';

// // const UserRoleCreateModal = ({ open, onClose, modalHeadingName }) => {
// //     const [activeTab, setActiveTab] = useState("Dashboard");

// //     const initialValues = {
// //         userrole: "",
// //         status: "Active",
// //         permissions: {
// //             Dashboard: {
// //                 Dashbord: { add: false, edit: false, delete: false, view: false },
// //             },
// //             OperatorRegistration: {
// //                 purchaserList: { add: false, edit: false, delete: false, view: false },
// //                 purchaserList: { add: false, edit: false, delete: false, view: false },
// //                 purchaserList: { add: false, edit: false, delete: false, view: false },
// //                 purchaserList: { add: false, edit: false, delete: false, view: false },

// //             },
// //             SchemeManagement: {
// //                 referrerList: { add: false, edit: false, delete: false, view: false },
// //             },
// //             ContentManagement: {
// //                 financialConsultantList: {
// //                     add: false,
// //                     edit: false,
// //                     delete: false,
// //                     view: false,
// //                 },
// //             },
// //         },
// //     };

// //     const handleSubmit = (values) => {
// //         console.log("Form Data:", values);
// //     };

// //     return (
// //         <Dialog
// //             open={open}
// //             onClose={onClose}
// //             fullWidth
// //             maxWidth="md"
// //             className="custom-dialog"
// //             sx={{
// //                 "& .MuiPaper-root": {
// //                     borderRadius: "14px",
// //                 },
// //             }}
// //         >
// //             <Box sx={{ position: 'relative' }}>
// //                 <Box className="dialog-heading">
// //                     <IconButton
// //                         aria-label="Close"
// //                         onClick={onClose}
// //                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
// //                     >
// //                         <MdCancel />
// //                     </IconButton>
// //                     <DialogTitle className="custom-dialog-title">
// //                         <Box>
// //                             <Typography className="custom-title-text" color='white'>
// //                                 {modalHeadingName}
// //                             </Typography>
// //                         </Box>
// //                     </DialogTitle>
// //                 </Box>

// //                 <Formik
// //                     initialValues={initialValues}
// //                     onSubmit={handleSubmit}
// //                 >
// //                     {({ values, setFieldValue }) => (
// //                         <Form className="create-user-role">
// //                             <DialogContent dividers>
// //                                 <Grid container spacing={2}>
// //                                     <Grid item xs={12}>
// //                                         <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
// //                                             <Grid item >

// //                                                 <CustomInputLogin
// //                                                     label="User Role"
// //                                                     name="userrole"
// //                                                     inputType="text"
// //                                                     custPlaceholder="Enter User Role"
// //                                                 />
// //                                             </Grid>
// //                                             <Grid item>

// //                                                 <ActiveInactiveRadio name="status"
// //                                                     value={values.status} // Ensure this is correctly passed from Formik
// //                                                     onChange={(value) => setFieldValue('status', value)}// Update the Formik state when the radio button changes
// //                                                 />
// //                                             </Grid>

// //                                         </Grid>

// //                                         <Grid sx={{py:2}}>
// //                                             <UserRoleTab values={values} setFieldValue={setFieldValue} />
// //                                         </Grid>
// //                                         {/* Tab Navigation */}

// //                                         {/* Submit Button */}
// //                                         <button type="submit">Submit</button>
// //                                     </Grid>
// //                                 </Grid>
// //                             </DialogContent>
// //                         </Form>
// //                     )}
// //                 </Formik>
// //             </Box>
// //         </Dialog>
// //     );
// // };

// // export default UserRoleCreateModal;

// // // ....................................................

// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   IconButton,
//   Box,
//   Typography,
//   Grid,
//   DialogContent,
// } from "@mui/material";
// import { MdCancel } from "react-icons/md";
// import { Formik, Form } from "formik";
// import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
// import UserRoleTab from "./UserRoleTab/UserRoleTab";

// const UserRoleCreateModal = ({ open, onClose, modalHeadingName }) => {
//   const initialValues = {
//     permissions: {
//       Dashboard: {
//         Dashboard: { add: false, edit: false, delete: false, view: false },
//       },
//       OperatorRegistration: {
//         "All User List": {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//         "Purchaser List": {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//         "Referrer List": {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//         "Financial Consultant List": {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//       },
//       SchemeManagement: {
//         "Gold Stake Schemes": {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//         "Referral Schemes": {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//       },
//       ContentManagement: {
//         Home: { add: false, edit: false, delete: false, view: false },
//         "Stake Now": { add: false, edit: false, delete: false, view: false },
//         "About Us": { add: false, edit: false, delete: false, view: false },
//         Blog: { add: false, edit: false, delete: false, view: false },
//         "Contact Us": { add: false, edit: false, delete: false, view: false },
//       },
//     },
//   };

//   const handleSubmit = (values) => {
//     console.log("Form Values:", values); // Debugging step

//     const sanitizedPermissions = {};

//     // Iterate through the permissions object to retain only checked values
//     Object.keys(values.permissions).forEach((category) => {
//       sanitizedPermissions[category] = {};
//       Object.keys(values.permissions[category]).forEach((subCategory) => {
//         sanitizedPermissions[category][subCategory] = {};
//         Object.keys(values.permissions[category][subCategory]).forEach(
//           (action) => {
//             sanitizedPermissions[category][subCategory][action] =
//               values.permissions[category][subCategory][action] || false;
//           }
//         );
//       });
//     });

//     console.log("Sanitized Form Data:", values.userrole, sanitizedPermissions);
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="md"
//       sx={{
//         "& .MuiPaper-root": {
//           borderRadius: "14px",
//         },
//       }}
//     >
//       <Box sx={{ position: "relative" }}>
//         <Box className="dialog-heading">
//           <IconButton
//             aria-label="Close"
//             onClick={onClose}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               color: "text.secondary",
//             }}
//           >
//             <MdCancel />
//           </IconButton>
//           <DialogTitle>
//             <Typography color="white">{modalHeadingName}</Typography>
//           </DialogTitle>
//         </Box>

//         <Formik initialValues={initialValues} onSubmit={handleSubmit}>
//           {({ values, setFieldValue }) => (
//             <Form>
//               <DialogContent dividers>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <Grid
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         flexDirection: { xs: "column", md: "row" },
//                       }}
//                     >
//                       <Grid item>
//                         <CustomInputLogin
//                           label="User Role"
//                           name="userrole"
//                           inputType="text"
//                           custPlaceholder="Enter User Role"
//                         />
//                       </Grid>
//                       <Grid item>
//                         <ActiveInactiveRadio
//                           name="status"
//                           value={values.status}
//                           onChange={(value) => setFieldValue("status", value)}
//                         />
//                       </Grid>
//                     </Grid>

//                     <Grid sx={{ py: 2 }}>
//                       <UserRoleTab
//                         values={values}
//                         setFieldValue={setFieldValue}
//                       />
//                     </Grid>

//                     {/* Submit Button */}
//                     <button type="submit">Submit</button>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//             </Form>
//           )}
//         </Formik>
//       </Box>
//     </Dialog>
//   );
// };

// export default UserRoleCreateModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  Grid,
  DialogContent,
  Button,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import { Formik, Form } from "formik";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
import UserRoleTab from "./UserRoleTab/UserRoleTab";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions/index";
import { toast, ToastContainer } from "react-toastify";
import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";

const UserRoleCreateModal = ({ open, onClose, modalHeadingName }) => {
  const dispatch = useDispatch();
  // const initialValues = {
  //     userrole: "",
  //     status: "Active",
  //     permissions: {
  //         Dashboard: { dashboard: { add: false, edit: false, delete: false, view: false } },
  //         OperatorRegistration: {
  //             allUserList: { add: false, edit: false, delete: false, view: false },
  //             purchaserList: { add: false, edit: false, delete: false, view: false },
  //             refferList: { add: false, edit: false, delete: false, view: false },
  //             financeConsultantList: { add: false, edit: false, delete: false, view: false },
  //         },
  //         SchemeManagement: {
  //             goldStakeSchemes: { add: false, edit: false, delete: false, view: false },
  //             referralSchemes: { add: false, edit: false, delete: false, view: false },
  //         },
  //         ContentManagement: {
  //             home: { add: false, edit: false, delete: false, view: false },
  //             stakeNow: { add: false, edit: false, delete: false, view: false },
  //             referrals: { add: false, edit: false, delete: false, view: false },
  //             blogs: { add: false, edit: false, delete: false, view: false },
  //             contactUs: { add: false, edit: false, delete: false, view: false },
  //         },
  //     },
  // };

  const defaultInitialValues = {
    userrole: "",
    status: "Active",
    permissions: {
      Dashboard: {
        Dashboard: { add: false, edit: false, delete: false, view: false },
      },
      OperatorRegistration: {
        "All User List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        "Purchaser List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        "Referrer List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        "Financial Consultant List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
      },
      SchemeManagement: {
        "Gold Stake Schemes": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        // "Referral Schemes": {
        //   add: false,
        //   edit: false,
        //   delete: false,
        //   view: false,
        // },
      },
      ContentManagement: {
        Home: { add: false, edit: false, delete: false, view: false },
        "Stake Now": { add: false, edit: false, delete: false, view: false },
        Referrals: { add: false, edit: false, delete: false, view: false },
        
        "About Us": { add: false, edit: false, delete: false, view: false },
        Blog: { add: false, edit: false, delete: false, view: false },
        "Contact Us": { add: false, edit: false, delete: false, view: false },
      },
    },
  };

  //   const initialValues = {
  //     userrole: editData?.userrole || "",
  //     status: editData?.status || "Active",
  //     permissions: editData?.permissions || defaultPermissions,
  // };


  const TableId = useSelector((state) => state.Table.TableId);
  console.log(TableId, "tableIddddddd")
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);

  const { getPermissionsForAuthUser } = useSelector((state) => state?.getPermissionsForAuthUser);
  const { updateAllPermissionsForAuthUser } = useSelector((state) => state?.updateAllPermissionsForAuthUser);

  const [editData, setEditData] = useState([])
  console.log(editData, "editDatattatattatata")

  useEffect(() => {
    if (!open) return; // Only fetch when modal is open
    console.log("itssssssss")
    if (TableId) {
      const fetchData = async () => {
        try {

          const data1 = {
            data: {},
            method: "get",
            apiName: `getPermissionsForAuthUser/${TableId}`,
          };
          const responseData = await dispatch(actions.GETPERMISSIONSFORAUTHUSER(data1));
          setEditData(responseData)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      fetchData();
    }

  }, [dispatch, open]);



  const { createRoleWithPermissions } = useSelector(
    (state) => state?.createRoleWithPermissions
  );

  const initialValues = editData ? editData : defaultInitialValues;



  const [formValues, setFormValues] = useState(
    defaultInitialValues
  );

  console.log(formValues, "formvalueeeeejej")



  // useEffect(() => {
  //   if (editData?.payload?.data) {
  //     console.log(editData?.payload?.data?.permissions, "dataftatattatatat")

  //     setFormValues(editData?.payload?.data?.permissions)
  //   } else {
  //     setFormValues(defaultInitialValues);
  //     // setUploadedFile(null)
  //   }
  // }, [editData, open]);


  useEffect(() => {
    if (editData?.payload?.data?.permissions) {
      console.log(editData?.payload?.data?.permissions, "Updated Permissions Data");

      setFormValues((prevValues) => (
        // ...prevValues,
        // permissions: editData?.payload?.data?.permissions, // Correctly set permissions
        {
          userrole: editData?.payload?.data?.roleName,
          permissions: editData?.payload?.data?.permissions
        }
      ));
    } else {
      setFormValues(defaultInitialValues);
    }
  }, [editData, open]);


  const token = localStorage.getItem('AuthToken');

  const handleSubmit = async (values, resetForm) => {
    console.log("user role creation", values); // Debugging step


    console.log("Transformed Data Old:", values); // Debugging step




    // Convert the permissions structure to the required format
    const transformedPermissions = Object.keys(values.permissions).reduce((acc, module_name) => {
      const screens = values.permissions[module_name];

      // Iterate through the screens in each module and transform the structure
      Object.keys(screens).forEach(screen_name => {
        const screen = screens[screen_name];
        acc.push({
          module_name: module_name,
          screen_name: screen_name,
          add: screen.add,
          edit: screen.edit,
          delete: screen.delete,
          view: screen.view
        });
      });

      return acc;
    }, []);

    // const transformedPermissions = Object.keys(values.permissions).reduce((acc, module_name) => {
    //   const screens = values.permissions[module_name];

    //   Object.keys(screens).forEach(screen_name => {
    //     const screen = screens[screen_name];

    //     // Check if at least one permission is true
    //     if (screen.add || screen.edit || screen.delete || screen.view) {
    //       acc.push({
    //         module_name,
    //         screen_name,
    //         add: screen.add,
    //         edit: screen.edit,
    //         delete: screen.delete,
    //         view: screen.view
    //       });
    //     }
    //   });

    //   return acc;
    // }, []);


    // Now we have the transformed permissions
    const transformedData = {
      roleName: values.userrole,
      permissions: transformedPermissions
    };

    console.log("Transformed Data New:", transformedData); // Debugging step


    if (!TableId) {
      const data1 = {
        data: transformedData,
        method: "post",
        apiName: `createRoleWithPermissions`,
        headers: {
          Authorization: `Bearer ${token}`,  // Pass auth token in headers
          "Content-Type": "application/json",
        },
      };
      const createRoleWithPermissionsResponse = await dispatch(
        actions.CREATEROLEWITHPERMISSIONS(data1)
      );

      if (
        createRoleWithPermissionsResponse.payload.message === "Role and permissions created successfully!"
      ) {
        toast.success(`${createRoleWithPermissionsResponse.payload.message}`);

        resetForm();

        setTimeout(() => onClose(), 1500);
        dispatch(clearTableGetId(null))
        dispatch(clearCustomerId(null))
      } else {
        toast.error(`${createRoleWithPermissionsResponse.payload.message}`);
      }
    } else {
      const data1 = {
        data: {
          ...transformedData,
          role_id: TableId

        },
        method: "put",
        apiName: `updateAllPermissionsForAuthUser`,
        headers: {
          Authorization: `Bearer ${token}`,  // Pass auth token in headers
          "Content-Type": "application/json",
        },
      };
      const updateRoleWithPermissionsResponse = await dispatch(
        actions.UPDATEALLPERMISSIONSFORAUTHUSER(data1)
      );

      if (
        updateRoleWithPermissionsResponse.payload.message === "Permissions updated successfully!"
      ) {
        toast.success(`${updateRoleWithPermissionsResponse.payload.message}`);

        resetForm();

        setTimeout(() => onClose(), 1500);
        dispatch(clearTableGetId(null))
        dispatch(clearCustomerId(null))

      } else {
        toast.error(`${updateRoleWithPermissionsResponse.payload.message}`);
      }

    }
  };

  return (
    <Dialog
      open={open}
      // onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "14px",
        },
      }}
    >

      <Box sx={{ position: "relative" }}>
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={() => {
              onClose()
              dispatch(clearTableGetId(null))
              dispatch(clearCustomerId(null))


            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle>
            <Typography color="white">{TableId ? "Edit User Role" : modalHeadingName}</Typography>
          </DialogTitle>
        </Box>

        <Formik enableReinitialize initialValues={formValues} onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}>
          {({ values, setFieldValue, resetForm }) => (
            <Form>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: { xs: "column", md: "row" },
                      }}
                    >
                      <Grid item>
                        <CustomInputLogin
                          label="User Role"
                          name="userrole"
                          inputType="text"
                          custPlaceholder="Enter User Role"
                        />
                      </Grid>
                      <Grid item>
                        {/* <ActiveInactiveRadio
                          name="status"
                          value={values.status}
                          onChange={(value) => setFieldValue("status", value)}
                        /> */}
                      </Grid>
                    </Grid>

                    <Grid sx={{ py: 2 }}>
                      <UserRoleTab
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    </Grid>
                    <Grid
                      sx={{ display: "flex", justifyContent: "end", mt: 4 }}
                    >
                      <Grid>
                        <Button
                          onClick={() => {
                            resetForm();
                            onClose()
                            dispatch(clearTableGetId(null))
                            dispatch(clearCustomerId(null))
                            // setUploadedFiles(null);
                          }}
                          variant="text"
                          // className="custom-clear-button"
                          sx={{
                            // backgroundColor: "#C38F51",
                            textTransform: "none",
                            color: "white",
                            fontSize: "16px",
                            mr: "10px",
                            // padding: "0px 40px",
                            padding: { xs: "0px 20px", md: "0px 40px" },

                            minHeight: "40px",
                            borderRadius: "23px",
                            background: "white",
                            boxShadow: "none",
                            color: "black",
                            border: "1px solid black",
                            "&:hover": {
                              backgroundColor: "#3B4056",
                              color: "white",
                            },
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          // className="custom-ok-button"
                          sx={{
                            // backgroundColor: "#C38F51",
                            textTransform: "none",
                            color: "white",
                            fontSize: "16px",
                            boxShadow: "none",

                            // padding: "0px 40px",
                            padding: { xs: "0px 20px", md: "0px 40px" },

                            minHeight: "40px",
                            borderRadius: "23px",
                            background: "#C38F51 0% 0% no-repeat padding-box",
                            "&:hover": {
                              backgroundColor: "#3B4056",
                              boxShadow: "none",
                            },
                          }}
                        >
                          {TableId ? "Update" : "Submit"}
                        </Button>
                      </Grid>
                    </Grid>
                    {/* Submit Button */}
                    {/* <button type="submit">Submit</button> */}
                  </Grid>
                </Grid>
              </DialogContent>
            </Form>
          )}
        </Formik>

        {/* <ToastContainer
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        /> */}
      </Box>
    </Dialog>
  );
};

export default UserRoleCreateModal;

// // // ...............................................

// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   IconButton,
//   Box,
//   Typography,
//   Grid,
//   DialogContent,
// } from "@mui/material";
// import { MdCancel } from "react-icons/md";
// import { Formik, Form } from "formik";
// import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
// import UserRoleTab from "./UserRoleTab/UserRoleTab";

// const UserRoleCreateModal = ({ open, onClose, modalHeadingName }) => {
//   const initialValues = {
//     userrole: "",
//     status: "Active",
//     permissions: {
//       Dashboard: {
//         Dashboard: { add: false, edit: false, delete: false, view: false },
//       },
//       OperatorRegistration: {
//         allUserList: { add: false, edit: false, delete: false, view: false },
//         purchaserList: { add: false, edit: false, delete: false, view: false },
//         refferList: { add: false, edit: false, delete: false, view: false },
//         financeConsultantList: {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//       },
//       SchemeManagement: {
//         goldStakeSchemes: {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//         referralSchemes: {
//           add: false,
//           edit: false,
//           delete: false,
//           view: false,
//         },
//       },
//       ContentManagement: {
//         home: {
//           banner: { add: false, edit: false, delete: false, view: false },
//           offer: { add: false, edit: false, delete: false, view: false },
//           threeSteps: { add: false, edit: false, delete: false, view: false },
//           Faqs: { add: false, edit: false, delete: false, view: false },
//         },
//         stakeNow: {
//           banner: { add: false, edit: false, delete: false, view: false },
//           offer: { add: false, edit: false, delete: false, view: false },
//         },
//         referrals: {
//           banner: { add: false, edit: false, delete: false, view: false },

//           threeSteps: { add: false, edit: false, delete: false, view: false },
//           Faqs: { add: false, edit: false, delete: false, view: false },
//         },
//         blogs: {
//           Faqs: { add: false, edit: false, delete: false, view: false },
//         },
//         contactUs: {
//           threeSteps: { add: false, edit: false, delete: false, view: false },
//           Faqs: { add: false, edit: false, delete: false, view: false },
//         },
//       },
//     },
//   };

//   const handleSubmit = (values) => {
//     console.log("Form Values:", values); // Debugging step

//     const sanitizedPermissions = {};

//     // Iterate through the permissions object to retain only checked values
//     Object.keys(values.permissions).forEach((category) => {
//       sanitizedPermissions[category] = {};
//       Object.keys(values.permissions[category]).forEach((subCategory) => {
//         sanitizedPermissions[category][subCategory] = {};
//         Object.keys(values.permissions[category][subCategory]).forEach(
//           (action) => {
//             sanitizedPermissions[category][subCategory][action] =
//               values.permissions[category][subCategory][action] || false;
//           }
//         );
//       });
//     });

//     console.log("Sanitized Form Data:", values.userrole, sanitizedPermissions);
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="md"
//       sx={{
//         "& .MuiPaper-root": {
//           borderRadius: "14px",
//         },
//       }}
//     >
//       <Box sx={{ position: "relative" }}>
//         <Box className="dialog-heading">
//           <IconButton
//             aria-label="Close"
//             onClick={onClose}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               color: "text.secondary",
//             }}
//           >
//             <MdCancel />
//           </IconButton>
//           <DialogTitle>
//             <Typography color="white">{modalHeadingName}</Typography>
//           </DialogTitle>
//         </Box>

//         <Formik initialValues={initialValues} onSubmit={handleSubmit}>
//           {({ values, setFieldValue }) => (
//             <Form>
//               <DialogContent dividers>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <Grid
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         flexDirection: { xs: "column", md: "row" },
//                       }}
//                     >
//                       <Grid item>
//                         <CustomInputLogin
//                           label="User Role"
//                           name="userrole"
//                           inputType="text"
//                           custPlaceholder="Enter User Role"
//                         />
//                       </Grid>
//                       <Grid item>
//                         <ActiveInactiveRadio
//                           name="status"
//                           value={values.status}
//                           onChange={(value) => setFieldValue("status", value)}
//                         />
//                       </Grid>
//                     </Grid>

//                     <Grid sx={{ py: 2 }}>
//                       <UserRoleTab
//                         values={values}
//                         setFieldValue={setFieldValue}
//                       />
//                     </Grid>

//                     {/* Submit Button */}
//                     <button type="submit">Submit</button>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//             </Form>
//           )}
//         </Formik>
//       </Box>
//     </Dialog>
//   );
// };

// export default UserRoleCreateModal;
